export const MaskCPF = (v: string): string => {
  if (!v) return '';

  v = String(v);
  v = v.replace(/\D/g, '');
  v = v.replace(/(\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  return v;
};

export const MaskCNPJ = (v: string): string => {
  if (!v) return '';

  v = String(v);
  v = v.replace(/\D/g, '');
  v = v.replace(/(\d{2})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d)/, '$1/$2');
  v = v.replace(/(\d)(\d{2})$/, '$1-$2');
  return v;
};
export const normalizeCpfCnpj = (v: string): string => {
  if (!v) return '';

  const digits = String(v).replace(/\D/g, '');
  return digits.length === 14 ? MaskCNPJ(digits) : MaskCPF(digits);
};

export const maskTEL = (v: string): string => {
  if (!v) return '';

  v = String(v);
  v = v.replace(/\D/g, '');
  v = v.replace(/^(\d{2})(\d)/g, '($1) $2');
  v = v.replace(/(\d)(\d{4})$/, '$1-$2');
  return v;
};

// Máscara progressiva de telefone BR, aplicada enquanto a pessoa digita:
// até 10 dígitos usa (11) 8877-6655 e no 11º passa para (11) 98877-6655.
// Limita a 11 dígitos (DDD + número) e descarta o +55 de um número colado.
export const maskPhoneBR = (v: string): string => {
  let digits = String(v ?? '').replace(/\D/g, '');
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  digits = digits.slice(0, 11);

  if (digits.length === 0) return '';
  if (digits.length <= 2) return `(${digits}`;

  const ddd = digits.slice(0, 2);
  const number = digits.slice(2);

  if (number.length <= 4) return `(${ddd}) ${number}`;
  if (digits.length <= 10)
    return `(${ddd}) ${number.slice(0, 4)}-${number.slice(4)}`;
  return `(${ddd}) ${number.slice(0, 5)}-${number.slice(5)}`;
};

const BR_DDDS = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35,
  37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64,
  65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88,
  89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

// Telefone BR válido: DDD existente + 8 dígitos (ex: (11) 8877-6655) ou
// 9 dígitos começando com 9 (ex: (11) 98877-6655). Recusa números com todos
// os dígitos iguais (ex: (11) 99999-9999).
export const isValidPhoneBR = (v: string): boolean => {
  const digits = String(v ?? '').replace(/\D/g, '');

  if (digits.length !== 10 && digits.length !== 11) return false;
  if (!BR_DDDS.has(Number(digits.slice(0, 2)))) return false;

  const number = digits.slice(2);
  if (number.length === 9 && number[0] !== '9') return false;
  if (/^(\d)\1+$/.test(number)) return false;

  return true;
};

export const maskLimited = (v: string): string => {
  if (!v) {
    return '';
  }
  v = String(v);
  v = v.slice(0, -1);
  return v;
};

export const maskCEP = (v: string): string => {
  if (!v) {
    return '';
  }
  v = v.replace(/\D/g, '');
  v = v.replace(/^(\d{5})(\d)/, '$1-$2');
  return v;
};

export const maskMoney = (valor: number): string => {
  if (!valor) {
    return '';
  }
  const valorStr = valor.toString();

  return valorStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const maskCurrency = (v: string): string => {
  if (!v) return '';

  let digits = v.replace(/\D/g, '');

  digits = digits.replace(/^0+/, '') || '0';

  digits = digits.padStart(3, '0');

  const decimalPart = digits.slice(-2);
  const integerPart = digits.slice(0, -2);

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formattedInteger},${decimalPart}`;
};

export const maskMoneyWithText = (valor: number): string => {
  if (!valor) {
    return '';
  }

  if (valor >= 1000000) {
    const valorEmMilhoes = valor / 1000000;
    // Verifica se a parte decimal é zero
    if (valorEmMilhoes % 1 === 0) {
      return valorEmMilhoes.toFixed(0) + 'M'; // Sem casas decimais
    } else {
      // Remove o ".0" se houver, caso contrário mantém 1 casa decimal
      const valorFormatado = valorEmMilhoes.toFixed(1).replace(/\.0$/, '');
      return valorFormatado.replace('.', ',') + 'M';
    }
  } else if (valor >= 1000) {
    const valorEmMilhares = valor / 1000;
    // Verifica se a parte decimal é zero
    if (valorEmMilhares % 1 === 0) {
      return valorEmMilhares.toFixed(0) + ' mil'; // Sem casas decimais
    } else {
      // Remove o ".0" se houver, caso contrário mantém 1 casa decimal
      const valorFormatado = valorEmMilhares.toFixed(1).replace(/\.0$/, '');
      return valorFormatado.replace('.', ',') + ' mil';
    }
  }
};
